import React from 'react';
import styles from './FormField.module.scss';

interface PortalInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

export function PortalInput({ hasError, className, ...props }: PortalInputProps) {
  const classes = [styles.portalInput, hasError ? styles.inputError : '', className].filter(Boolean).join(' ');
  return <input className={classes} {...props} />;
}

interface PortalTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  hasError?: boolean;
}

export function PortalTextarea({ hasError, className, ...props }: PortalTextareaProps) {
  const classes = [styles.portalInput, styles.textarea, hasError ? styles.inputError : '', className]
    .filter(Boolean)
    .join(' ');
  return <textarea className={classes} {...props} />;
}
